import React from 'react';
import { bool, func } from 'prop-types';
import { Dropdown } from 'antd';

// Import styles
import { ButtonStyled, ProfileIconStyled, Username } from './styles';

// Import hooks
import { useNavDropdown } from './useNavDropdown';

const NavDropdown = ({ isMobile, toggle = () => {}, isOpen = false }) => {
	const {
		menu,
		unauthorizedMenu,
		authButtons,
		login,
		isAuth,
		handleDropdownClick
	} = useNavDropdown({
		isMobile,
		isOpen,
		toggle
	});

	if (!isAuth && !isMobile) return authButtons;

	return (
		<Dropdown
			overlay={isMobile && !isAuth ? unauthorizedMenu : menu}
			trigger={['click']}
			onClick={handleDropdownClick}
		>
			<ButtonStyled modifiers={['navIcon']}>
				<ProfileIconStyled />
				{login && <Username>{login}</Username>}
			</ButtonStyled>
		</Dropdown>
	);
};

NavDropdown.propTypes = {
	isMobile: bool,
	toggle: func,
	isOpen: bool
};

export default NavDropdown;
